var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",staticStyle:{"max-height":"600px","padding-top":"300px"},attrs:{"align":"center"}},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Connection in progress")]),_c('br'),_c('br'),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"red darken-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }